import verifytick from "../../assets/verify-tick.png";
import "./VirtualPoojaBookingView.scss";
import MasonryGrid from "../../components/MasonryGrid/MasonryGrid";
import Carousel from "react-multi-carousel";
import {
  Box,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  Avatar,
  ListItemText,
} from "@mui/material";
import ImageViewer from "../../components/imageviewer/ImageViewer";
import templeIcon from "../../../src/assets/temple-icon.png";
import locationIcon from "../../../src/assets/loc-icon.png";
import ratingIcon from "../../../src/assets/rate-star.png";
import VirtualPujaBookDialog from "../../components/dialog/VirtualPujaBookDialog";
import {
  LOCALSTORAGE_KEY,
  orderType,
  VIRTUAL_PUJA_BOOKINGCAROUSAL_RESPONSIVE,
} from "../../utils/Constants";
import ShareLink from "../../components/sharelink/sharelink";
import { useEffect, useState } from "react";
import ImageViewerWithBlur from "../../components/imageviewer/ImageViewerWithBlur";
import {
  getCityStateFromTemple,
  getConcatenatedTempleNames,
  getOfferPriceFromV1,
  getOneImageForTemple,
  getTempleName,
} from "../../utils/HelperFunctions";
import { useSelector } from "react-redux";
import TempleServiceListCard from "../../components/card/TempleServiceListCard/TempleServiceListCard";
import { LOCALIZATION } from "../../utils/localization";
import { useTranslation } from "react-i18next";

function VirtualPujaBookingView(props: any) {
  const [urlToShare, setUrlToShare] = useState<string>("");
  const [filterPujaList, setFilterPujaList] = useState<any>([]);

  // const [selectedStaticPujaNameKey, setSelectedStaticPujaNameKey] = useState<string>('Loan-Mukti-Puja')
  // const [selectedStaticPujaPrice, setSelectedStaticPujaPrice] = useState<number>(72250)
  const { t } = useTranslation();
  const priceConversionState = useSelector(
    (state: any) => state?.priceConversion,
  );

  const {
    rate = 1,
    currencySymbols = "₹",
    isOverseas = false,
  } = priceConversionState?.priceConversionRate || {};

  const savedLanguage =
    localStorage.getItem(LOCALSTORAGE_KEY.LANG_CODE) ?? "en";
  const templeTitle = getTempleName(props?.templeDetails, savedLanguage);

  const personalInfo = props?.templeDetails?.personalInfo;
  const templeAddress = getCityStateFromTemple(personalInfo);

  useEffect(() => {
    const hostname =
      window.location.hostname === "localhost"
        ? "http://localhost:3000"
        : "https://" + window.location.hostname;
    setUrlToShare(
      `${hostname}/pagelink?pujaType=templePujas&templeNameKey=${props?.templeDetails?.nameKey}`,
    );

    if (props?.templeDetails?.templePuja?.length > 0) {
      const templePuja =
        [...props?.templeDetails?.templePuja]
          ?.filter((item: any) => !item?.isPujaDisable)
          ?.sort(
            (a: any, b: any) =>
              parseInt(b?.position || 0) - parseInt(a?.position || 0),
          ) ?? [];
      setFilterPujaList(templePuja);
    }
  }, [props.templeDetails]);

  return (
    <Box className="pageContainer pujaBookingPage">
      <Box className="pujaBookingBlock">
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={2}>
            <Grid
              item
              xs={12}
              md={2}
              lg={2}
              xl={2}
              className="pujaBookingLeftBlock"
            >
              {/* <LeftAddressCard
                header="Current Address"
                address="198/3, 3 Cross 80 Feet Road, Next.."
                footerButton="Edit or add an address"
              /> */}
            </Grid>
            <Grid item xs={12} md={8} lg={8} xl={8}>
              <Box className="pujaBookingCenterBlock">
                <Box className="pujaBookingTopBanner" data-scroll-id={"virtual-puja-details-banner"}>
                  <Box style={{ zIndex: -10 }}>
                    {props.templeMediaList.length > 0 ? (
                      <Carousel
                        responsive={VIRTUAL_PUJA_BOOKINGCAROUSAL_RESPONSIVE}
                        swipeable={true}
                        draggable={true}
                        showDots={true}
                        keyBoardControl={true}
                        removeArrowOnDeviceType={["tablet", "mobile"]}
                      >
                        {props.templeMediaList.map((item2: any, id: any) => {
                          return (
                            <ImageViewerWithBlur
                              id={id}
                              url={item2.pictureUrl}
                            />
                          );
                        })}
                      </Carousel>
                    ) : null}
                  </Box>
                  <Box className="shareIcon">
                    <ShareLink urlToShare={urlToShare} type="Temple Puja List"></ShareLink>
                  </Box>
                </Box>
                <Box className="pujaBookingTitle">
                  {/* <Typography>
                    {props.templePersonalInfo.name}{" "}
                    <ImageViewer id={0} pictureUrl={verifytick} />
                  </Typography> */}
                  <List>
                    <ListItem>
                      <ListItemAvatar sx={{ minWidth: "40px" }}>
                        <Avatar alt="Temple Icon" className="squreShape temple">
                          <img src={templeIcon} alt="temple Icon"></img>
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        sx={{ display: "flex", alignItems: "center" }}
                        primary={templeTitle}
                        secondary={
                          <ImageViewer id={0} pictureUrl={verifytick} />
                        }
                      />
                    </ListItem>

                    {templeAddress?.trim().length > 0 && (
                      <ListItem>
                        <ListItemAvatar sx={{ minWidth: "40px" }}>
                          <Avatar
                            alt="Location Icon"
                            className="squreShape location"
                          >
                            <img src={locationIcon} alt="location"></img>
                          </Avatar>
                        </ListItemAvatar>
                        <ListItemText
                          // primary={`${props.templePersonalInfo?.address?.area}, ${props.templePersonalInfo?.address?.state}`}
                          primary={templeAddress}
                        />
                      </ListItem>
                    )}

                    <ListItem>
                      <ListItemAvatar sx={{ minWidth: "40px" }}>
                        <Avatar alt="Rating Icon" className="squreShape rating">
                          <img src={ratingIcon} alt="rating"></img>
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={props?.templeDetails?.googleData?.rating}
                      />
                    </ListItem>
                  </List>
                </Box>
                <Box className="templeCenterBlock" data-scroll-id={"filter-puja-list"}>
                  {filterPujaList && filterPujaList.length > 0 && (
                    <MasonryGrid
                      items={filterPujaList}
                      renderItem={(item: any, id: number) => {
                        const singleTempleName = item?.personalInfo
                          ? getTempleName(
                              { personalInfo: item?.personalInfo },
                              savedLanguage,
                            )
                          : "";
                        const packageTempleName = getConcatenatedTempleNames(
                          item?.templeList,
                        );
                        const templeName =
                          singleTempleName || packageTempleName || "";

                        const templeAddress = item?.personalInfo
                          ? getCityStateFromTemple(item?.personalInfo)
                          : "";

                        const templeCardImage =
                          item?.pujaBg?.uri ||
                          getOneImageForTemple(
                            item?.personalInfo?.media?.pictures,
                          );
                        const updatedBenefitList =
                          item?.benefitList?.map((benefit: any) => {
                            const benefitDetails = props.benefitsList?.find(
                              (bnft: any) =>
                                bnft?.benefitId === benefit?.benefitId,
                            );
                            return benefitDetails
                              ? { ...benefit, ...benefitDetails }
                              : benefit;
                          }) || [];

                        const serviceBenefits = updatedBenefitList.map(
                          (benefit: any) => benefit?.name,
                        );
                        const basePrice = isOverseas
                          ? item?.overseasBasicPrice
                          : item?.indianBasicPrice;

                        const finalTotalPrice =
                          basePrice > 0
                            ? parseFloat((basePrice * rate)?.toFixed(2))
                            : 0;

                        const offerV1 =
                          item?.type === orderType?.pujaPackage
                            ? item?.priceBreakupV1
                            : item?.multiplePujaDetails?.length
                              ? item?.multiplePujaDetails[0]?.priceBreakupV1
                              : null;

                        const offerActualPrice = getOfferPriceFromV1(
                          offerV1,
                          isOverseas,
                          false,
                          rate,
                        );

                        const serviceTitle =
                          item?.type === orderType?.pujaPackage
                            ? item?.cardTitle || ""
                            : item?.pujaSpecialDesc || "";

                        return (
                          <TempleServiceListCard
                            key={`${item?.id}-${id}`}
                            templeData={{ pujaDetails: { ...item } }}
                            templeName={templeName}
                            templeAddress={templeAddress}
                            templeCardImage={templeCardImage}
                            overlayText={{
                              leftSideTextOverlay: item?.leftSideTextOverlay,
                              rightSideTextOverlay: item?.rightSideTextOverlay,
                            }}
                            overlayCss={item?.overlayCss ?? null}
                            serviceTitle={serviceTitle}
                            serviceDescription={item?.pujaName}
                            serviceBenefits={serviceBenefits}
                            serviceThithiName={item?.tithiName || ""}
                            finalTotalPrice={finalTotalPrice}
                            offerActualPrice={offerActualPrice}
                            currencySymbols={currencySymbols}
                            type={item?.type}
                            selectTemple={props?.onClickAddPuja}
                            actionLabel={
                              item?.type === orderType?.pujaPackage
                                ? t(LOCALIZATION?.Book_Package)
                                : t(LOCALIZATION?.View_to_participate)
                            }
                          />
                        );
                      }}
                    />
                  )}
                </Box>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={2}
              lg={2}
              xl={2}
              className="pujaBookingRightBlock"
            >
              {/* <RightBlockCard /> */}
            </Grid>
          </Grid>
        </Box>
      </Box>
      <VirtualPujaBookDialog
        setAskUserToModifyCartPopUp={props.setAskUserToModifyCartPopUp}
        userConfirmUpdatePujaDetails={props.userConfirmUpdatePujaDetails}
        askUserToModifyCartPopUp={props.askUserToModifyCartPopUp}
      />
    </Box>
  );
}

export default VirtualPujaBookingView;
